/**
 * Reconcile cached parquet files against the live bucket listing.
 *
 * The DuckDB VIEW is a UNION of every cached parquet file, so a file that
 * lingers in IndexedDB after being removed from the bucket double-counts its
 * rows. This computes both sides of the reconciliation:
 *   - toDownload: in the bucket but not cached  → fetch + register
 *   - toEvict:    cached but no longer in bucket → stale orphan, remove
 *
 * @param {Iterable<string>} cachedFileNames - file names currently in IndexedDB
 * @param {Iterable<string>} bucketFileNames - file names currently in the bucket
 * @returns {{ toDownload: string[], toEvict: string[] }}
 */
export const planParquetCacheSync = (cachedFileNames, bucketFileNames) => {
  const cached = new Set(cachedFileNames);
  const bucket = new Set(bucketFileNames);
  const toDownload = [...bucket].filter(name => !cached.has(name));
  const toEvict = [...cached].filter(name => !bucket.has(name));
  return { toDownload, toEvict };
};
